import React from 'react';
import imgAnn from '../../static/images/announcement.svg';
import imgNoData from '../../static/images/no_data.svg';

export default class Announce extends React.Component<any, any> {
    public render() {
        return (
            <div className="error-page create-announcement text-center">
                <div className="d-inline-block text-center">{this.props.children ? this.props.children : <img src={imgNoData} />}</div>
            </div>
        );
    }
}
